// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-wrap[data-v-d5a6b736]{border-radius:8px;height:360px}.card-empty[data-v-d5a6b736]{display:flex;justify-content:center;align-items:center;height:100%;color:#aaa;padding-top:20px}.card-empty[data-v-d5a6b736],.lookMore[data-v-d5a6b736]{font-weight:400;font-size:14px;text-align:center}.lookMore[data-v-d5a6b736]{margin-top:10px;cursor:pointer;color:#333}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
